import { Alert, Snackbar } from "@mui/material";
import React from "react";

const Message = (props) => {
  const { message, openMessage, closeMessage, severity } = props;
  return (
    <Snackbar
      autoHideDuration={2000}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      open={openMessage}
      onClose={closeMessage}
      key={"top"}
    >
      <Alert
        severity={severity}
        className="shadow-lg"
        sx={{ background: "white", color: "#161616" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Message;
